import {get, post, put} from './config';

const Employee = {
    getByEmployees: (companyId, page = 1, limit = 15) =>
        get(`v1/users/client/employees/${companyId}?page=${page}&limit=${limit}`),
    createEmployee: (data) =>
        post(`v1/users/client/create-employees`, data),
    getEmailByEmployee: (code) =>
        get(`v1/users/get-user-email/${code}`),
    setEmployeePassword: (code, data) =>
        post(`v1/users/client/employee-email-confirm/${code}`, data),
    getEmployee: (employeeId) =>
        get(`v1/users/client/employee/by-${employeeId}`),
    editEmployee: (employeeId, data) =>
        put(`v1/users/client/update-employees/${employeeId}`, data)
}

export default Employee;
